import { CheckCircle2, Copy } from "lucide-react";
import { toast } from "sonner";

export default function SuccessScreen({ applicationId }) {
  const copyId = async () => {
    try {
      await navigator.clipboard.writeText(applicationId);
      toast.success("Application ID copied");
    } catch {
      toast.error("Couldn't copy — long-press the ID to copy it");
    }
  };

  return (
    <main className="max-w-2xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <div className="step-enter rounded-3xl border-2 border-slate-200 bg-white shadow-lg p-6 sm:p-10 text-center space-y-6">
        <div className="mx-auto h-20 w-20 rounded-full bg-emerald-50 grid place-items-center">
          <CheckCircle2 className="h-11 w-11 text-emerald-600" />
        </div>

        <div className="space-y-3">
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">
            Application Received!
          </h1>
          <p className="text-base sm:text-lg text-slate-700 leading-relaxed">
            Thank you for your interest in joining CLiQ! Booths.
          </p>
          <p className="text-sm sm:text-base text-slate-500 leading-relaxed max-w-md mx-auto">
            Our team will review your application and contact you if your experience and availability match our
            current staffing needs.
          </p>
        </div>

        <div className="rounded-2xl bg-slate-900 px-6 py-5 inline-flex flex-col items-center gap-1.5">
          <span className="text-[11px] font-bold tracking-[0.25em] text-slate-400">APPLICATION ID</span>
          <div className="flex items-center gap-3">
            <span data-testid="application-id-display" className="font-mono font-bold text-white text-lg sm:text-xl">
              {applicationId}
            </span>
            <button
              type="button"
              data-testid="copy-application-id-btn"
              onClick={copyId}
              aria-label="Copy application ID"
              className="text-slate-400 hover:text-white transition-colors"
            >
              <Copy className="h-4 w-4" />
            </button>
          </div>
        </div>

        <div>
          <a
            data-testid="return-to-cliq-button"
            href="https://www.cliqbooths.com"
            className="inline-flex items-center justify-center h-[52px] px-8 rounded-xl bg-rose-600 text-white font-heading font-bold text-base shadow-md transition-all hover:bg-rose-700 active:scale-[0.98]"
          >
            Return to CLiQ! Booths
          </a>
        </div>
      </div>
    </main>
  );
}
